import { useState, useEffect, useRef } from 'react';
import { FeedCard } from '../card';
import styles from './style.module.scss';

const FEED_URL = '/minha-pagina/feed';

function mapApiItem(item) {
  const images = (item.photos || []).map(photo => photo.url).filter(Boolean);
  return {
    id: item.id,
    challengeId: item.id,
    title: item.title || null,
    state: item.state || null,
    city: item.city || null,
    images,
    comments: item.comments || [],
    likes: item.likes_count ?? 0,
    likedByMe: !!item.liked_by_me,
  };
}

export const FeedList = () => {
  const [items, setItems] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const [nextBeforeId, setNextBeforeId] = useState(null);
  const [nextBeforeDate, setNextBeforeDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const initialFetched = useRef(false);

  const fetchFeed = (beforeId = null, beforeDate = null) => {
    if (loading) return;
    setLoading(true);
    setError(null);

    let url = FEED_URL;
    if (beforeId && beforeDate) {
      url += `?before_id=${beforeId}&before_date=${encodeURIComponent(beforeDate)}`;
    }

    fetch(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then(r => r.json())
      .then(res => {
        const mapped = (res.data || []).map(mapApiItem);
        setItems(prev => [...prev, ...mapped]);
        setHasMore(!!res.has_more);
        setNextBeforeId(res.next_before_id || null);
        setNextBeforeDate(res.next_before_date || null);
      })
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (!initialFetched.current) {
      initialFetched.current = true;
      fetchFeed();
    }
  }, []);

  return (
    <div className={styles.feedListContainer}>
      {items.length === 0 && !loading && !error && (
        <p className={styles.emptyMessage}>Nenhuma foto encontrada.</p>
      )}

      <ul className={styles.feedList}>
        {items.map(feedItem => (
          <li
            key={feedItem.id}
            className={styles.feedListItem}
          >
            <FeedCard card={feedItem} />
          </li>
        ))}
      </ul>

      {hasMore && (
        <div className={styles.loadMoreWrapper}>
          <button
            type="button"
            className={styles.loadMoreButton}
            onClick={() => fetchFeed(nextBeforeId, nextBeforeDate)}
            disabled={loading}
          >
            {loading ? 'Carregando...' : 'Carregar mais'}
          </button>
        </div>
      )}

      {loading && items.length === 0 && (
        <div className={styles.loadMoreWrapper}>
          <span>Carregando...</span>
        </div>
      )}
    </div>
  );
};
